import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';

const Form = React.lazy(() => import('./Form'));

function CreateRefund(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>برگشت پول جدید</PageTitle>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <Form {...props} />
      </Suspense>
    </Page>
  );
}

export default CreateRefund;
